import styled from '@emotion/styled'
import React from 'react'

import { NoResults } from '@/components'
import { Key, KeyAccessType, KeyType } from '@/types/Key'

type Props = {
  accessType: KeyAccessType
  homeKeys: Key[]
  keyType: KeyType
}

export const HomeKeyDetails = ({ accessType, homeKeys, keyType }: Props) => {
  return (
    <div className="flex w-full flex-col py-4 px-2">
      <div className="mb-2 flex w-full items-center justify-between md:mb-4 md:flex-row">
        <h2 className="text-header-sm leading-120">
          {accessType} {keyType}s
        </h2>
      </div>
      <>
        {(homeKeys && homeKeys.map((homeKey, index) => <HomeKeyCard homeKey={homeKey} key={index} />)) || <NoResults />}
      </>
    </div>
  )
}

const HomeKeyCard = ({ homeKey }: { homeKey: Key }) => {
  const { accessType, keyType, ownership, serialNumber, id } = homeKey

  return (
    <BoxStyled role="presentation">
      <div className="home-key-information grid grid-cols-4">
        <div className="bordered-column">
          <h6>ID</h6>
          <p>{id}</p>
        </div>
        <div className="bordered-column">
          <h6>Key</h6>
          <p>
            {accessType} {keyType}
          </p>
        </div>
        <div className="bordered-column">
          <h6>Ownership</h6>
          <p>{ownership}</p>
        </div>
        <div className="pl-2">
          <h6>Serial Number</h6>
          <p>{serialNumber}</p>
        </div>
      </div>
    </BoxStyled>
  )
}

const BoxStyled = styled.div`
  padding: 0.75rem;
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 1rem;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.12);

  .home-key-information {
    div {
      display: flex;
      flex-direction: column;
    }

    h6 {
      color: #787573;
      font-size: var(--text-p-xs);
    }
    p {
      font-size: var(--text-p-xs);
      line-height: 1.2;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    p:hover {
      overflow: visible;
      white-space: normal;
      height: auto;
    }
  }

  .bordered-column {
    border-right-width: 1px;
    padding-left: 0.5rem;
    border-color: #e7e6e4;
  }
`
